export default function cxOperations(fetch, baseUrl) {
  return {
    updateUserDetails({ userId, requestBody }) {
      return fetch.patch(`${baseUrl}/user/${userId}/user-details`, requestBody);
    }
  };
}
